export const numberAsStringWithLimit = (counted: number, limiter = 999): string =>
  counted >= limiter ? `${limiter}+` : counted.toString();
